import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '绿豚陪诊 - 让每一次就医都有人陪' }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/ServicesView.vue'),
    meta: { title: '绿豚陪诊 - 核心业务' }
  },
  {
    path: '/team',
    name: 'team',
    component: () => import('../views/TeamView.vue'),
    meta: { title: '绿豚陪诊 - 招商合作' }
  },
  {
    path: '/qualification',
    name: 'qualification',
    component: () => import('../views/QualificationView.vue'),
    meta: { title: '绿豚陪诊 - 项目案例' }
  },
  {
    path: '/activities',
    name: 'activities',
    component: () => import('../views/ActivitiesView.vue'),
    meta: { title: '绿豚陪诊 - 活动动态' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: { title: '绿豚陪诊 - 联系我们' }
  },
  {
    path: '/tender',
    name: 'tender',
    component: () => import('../views/TenderView.vue'),
    meta: { title: '绿豚陪诊 - 招标信息' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue'),
    meta: { title: '绿豚陪诊 - 隐私政策' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) document.title = to.meta.title
  next()
})

export default router
